<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="1400">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">history</v-icon>
            {{ userData.email }} subscription history
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <SubscriptionHistoryBody :userId="userData.id"></SubscriptionHistoryBody>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'UserSubscriptionHistoryModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['userSubscriptionHistoryDialog', 'userData'],
  data () {
    return {
      dialog: this.userSubscriptionHistoryDialog
    }
  },
  mounted () {
  },
  watch: {
    userSubscriptionHistoryDialog: {
      handler () {
        this.dialog = this.userSubscriptionHistoryDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('userSubscriptionHistoryDialog', this.dialog)
      }
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserSubscriptionHistoryModal.vue